import { render } from "./ErrorPage404.vue?vue&type=template&id=2448148a&lang=html"
import script from "./ErrorPage404.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorPage404.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__